import { Components } from '@mui/material';

export const badge: Components = {
  MuiBadge: {
    styleOverrides: {
      badge: {
        paddingTop: '3px',
        fontSize: '0.7em',
      },
    },
  },
};
